import { Router } from '@angular/router';
import {
    Input,
    Output,
    Component,
    OnInit,
    OnDestroy,
    AfterViewInit,
    ChangeDetectorRef,
    ViewChild,
    EventEmitter,
    signal,
    WritableSignal,
} from '@angular/core';
import { RequestTools } from '@service/request.tools';
import { Tools } from '@service/tools';
import { BasketTools } from '@service/basket.tools';
import {
    currentSelectedBsk,
    currentRequest,
    currentBskProperty,
    infosMail,
    atfActions,
    setInfosMail,
    setToolbar,
    concatAllBasket,
    getBskAllowExt,
    getFileExt,
    getDelay,
    verifyDataEnter,
    verifyRequiredIndex,
    decodeUtf8,
    getProperty,
    getField,
    getDateInternal,
    getFileNameWithoutExt,
    getInternalPrefUsr,
    prepareExportExcel,
    convertStringToBoolean,
    replEmoji,
    formatUserList, getExportFileName,
} from '@core/_utils/tools.utils';
import { ApiV6Service } from '@service/apiv6.service';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { MenuItem } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { reqBas, AvailableModeView, extGed, AvailableBskTabDetail, AvailableSrcTabDetail } from '@documalis/_const/const';
import { CustomService } from '@custom/custom.service';
import { EditorService } from '@service/editor.service';
import { DockStandardService } from '@service/dockstandard.service';
import { RightService } from '@service/right.service';
import { ThumbsComponent } from './../thumbs';
import { DisplayResultGridComponent } from './../displayresultgrid';
import * as displayResultTools from './displayresult.tools';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { CheckTools } from '@service/check.tools';
import { dateFormat } from '@core/_utils/date.utils';
import { FormatRequestTools } from '@service/formatrequest.tools';
import { DocumentService } from '@service/document.service';
import { DocumentDetailComponent } from '../documentdetail';
import { PanelService } from '@service/panel.service';
import { TranslateService } from '@ngx-translate/core';
import {LoadingService} from "@core/_services/loading.service";
import { NotificationService } from '@service/notification.service';
import { setCurrentSelectedBsk } from '@core/_utils/basket.utils';
import { Subject, lastValueFrom } from 'rxjs';
import { IndexedDbService } from '@service/indexeddb.service';
import { DownloadService } from '@service/download.service';

@Component({
    selector: 'displayresult',
    templateUrl: 'displayresult.component.html',
    styleUrls: ['displayresult.component.scss'],
})
export class DisplayResultComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() public srchMode;
    @Input() public resultDisplay;
    @Input() public nbDoc;
    @Input() public btnAction;
    @Input() public curPage;
    @Input() public currentDocId;
    @Input() public listColumns: any[];
    @Input() public currentSelectedBsk: currentSelectedBsk;
    @Input() public listBskVariable: any[];
    @Input() public basketMoveAll: any[];
    @Input() public infoList: any[];
    @Input() public request: currentRequest;
    @Input() public isDesktop: boolean;
    @Input() public autoDocId;
    @Input() public fetchParam;

    @Output() public onReturnResult = new EventEmitter<any>();
    @Output() public onAction = new EventEmitter<any>();
    @Output() public onNextDocs = new EventEmitter<any>();

    public currentUser;
    public isAdmin = false;
    public error = false;
    public docInfos: any[];
    public docIndex: any[];
    public docIndexFiltered: any[];
    public docBasket: any;
    public docAtf: any[];
    public docVersion: WritableSignal<any[]>;   
    public pathPdf: string;
    public pathImg: string;
    public viewIndex = 0;
    public typeView = 2;
    public selectedDocsExport: any[];
    public rowIndex: number;
    public displayExport: boolean = false;
    public displayStat: boolean = false;
    public displayDelDocs: boolean = false;
    public displayMove: boolean = false;
    public displayIndexTransfert: boolean = false;
    public displayActions: boolean = false;
    public displayVersion: boolean = false;
    public displayCompose: boolean = false;
    public displayChangeDoc: boolean = false;
    public bskTypeMail: boolean = false;
    public bskMode: boolean = false;
    public displayBskVariableUpdate: boolean = false;
    public displayInfo: boolean = false;
    public actionGroup: boolean = false;
    public displaySendMail: boolean = false;
    public displayRename: boolean = false;
    public currentVer: string = '0000';
    public docIdVer: string = '';
    public docInfosVer: any[];
    public docIndexFilteredVer: any[];
    public splitId: string;
    public listColumnsWrk:any[];
    public userList:any[];

    public btnActionLabel: string;
    public btnActionModePdf: string;
    public btnActionModeView: string;
    public btnActionModeExport: string;
    public titleIndex: string;
    public titleDelete: string;

    public listBskVariableUpdate: any[];
    public bskVariableList: any[];

    public bskParamDock: any;

    public menuImage: MenuItem[];

    public currentBskProperty: currentBskProperty;
    // Déclarations pour les actions
    public currentAction;
    public bskDocDate;
    public currentTransfertBsk: currentSelectedBsk;
    public infosMail: infosMail;
    public infosMailDisplay: infosMail;
    public docIdList: any[];
    public variableStorage: any[];
    public numPage = 1;
    public pos = {
        x: 0,
        y: 0,
    };
    public dimension = {
        x: 600,
        y: 800,
    };

    public currentStamp;
    public currentActionDoc;
    public userInfos;
    public delay;
    public errorMessage = '';

    public currentDocName = '';
    public currentLockUser = '';
    public lockDate = '';
    public isLock: boolean = false;
    public itemConfirm: ItemConfirmComponent;
    public titleDetail = '';
    public lockHeader = 'Confirmation';
    public hasLock: boolean = false;
    public atfActions: atfActions;
    public btGridActionList: any[];
    public btDocActionList: any[];
    public sizeThumb: number = 160;
    public newDocName = '';
    public internalPrefUsr: any;
    public nbZoneDisplay = {};
    public docIdinBasket : boolean = false;
    public paramDetail;
    public visuGrid: number = 0;    // 1 : liste des résultats, 2 : détail d'un document
    private originClick = '';
    public modeView;
    public modeDetail;
    public reorgBsk: boolean = false;
    public sendToBsk: boolean = false;
    public currentAtf: string = '';
    public hideButton: boolean = false;
    public allowReorg: string = 'visible';
    public addNotif: boolean = false;
    public bskDockReorder: boolean = false;
    public srcDockReorder: boolean = false;
    public displayReorg: boolean = false;    
    public dockMode: boolean = false;
    public displayComm: boolean = false;
    public displayComm$: any;
    public waitIndex$: any;
    public outComm: {comment:
                    {comment: string,
                        notif: {destUser: string, notifMess: string}
                    },                     
                    outComment: boolean};
    @ViewChild('pdfViewer') pdfViewer;
    @ViewChild('thumb') public dataView: ThumbsComponent;
    @ViewChild('displayresultgrid') public displayresultgrid: DisplayResultGridComponent;
    @ViewChild('documentDetail') public documentDetail: DocumentDetailComponent;

    constructor(
        private api: ApiV6Service,
        private router: Router,
        private requestTools: RequestTools,
        public tools: Tools,
        public baskeList: BasketTools,
        protected _messageService: MessagesService,
        private auth: AuthService,
        private customService: CustomService,
        public editorService: EditorService,
        private cd: ChangeDetectorRef,
        public confirmationService: ConfirmationService,
        public dockStandardService: DockStandardService,
        public rightService: RightService,
        private checkTools: CheckTools,
        private formatRequestTools: FormatRequestTools,
        private documentService: DocumentService,
        private panelService : PanelService,
        private translate: TranslateService,
        private loadingService: LoadingService,
        private notifService: NotificationService,
        private indexedDbService: IndexedDbService,
        private downloadService: DownloadService
    ) {
        this.listBskVariableUpdate = new Array();
        this.bskVariableList = new Array();
        this.selectedDocsExport = new Array();
        this.menuImage = new Array();
        let wInternal = JSON.parse(atob(localStorage.getItem('intern')));
        this.userInfos = wInternal.internal;
        this.delay = wInternal.internalcfg;
        this.addNotif = convertStringToBoolean(wInternal.allowSendNotif);
        this.bskDockReorder = convertStringToBoolean(wInternal.bskDockReorder);
        this.srcDockReorder = convertStringToBoolean(wInternal.srcDockReorder);
        this.internalPrefUsr = getInternalPrefUsr();
        this.typeView = displayResultTools.getModeViewDoc(this.internalPrefUsr.modeViewDoc);
        this.isAdmin = this.auth.isAdmin();
        this.lockHeader = this.translate.instant('Conf');
        this.btnActionModePdf = this.translate.instant('Read_Pdf');
        this.btnActionModeView = this.translate.instant('grid');
        this.btnActionModeExport = this.translate.instant('Actions');
        this.bskParamDock = {
            varList: new Array(),
            srcList: new Array(),
            trgList: new Array(),
        };
        this.docIdList = new Array();
        this.btGridActionList = new Array();
        this.btDocActionList = new Array();
        this.userList = new Array();
        this.docVersion = signal([]);

        window.addEventListener('storage', (event) => {
            if (event.storageArea != localStorage) return;
            if (event.key === 'viewMode') {
                    switch (event.oldValue) {
                        case '0' : {
                            this.goTypeView0('')
                            break;
                        }
                        case '1' : {
                            this.goTypeView1('')
                            break;
                        }
                        case '2' : {
                            this.goTypeView2('')
                            break;
                        }
                        default :{
                            this.goTypeView0('')
                            break;
                        }
                    }
            }
        });
    }

    public ngOnInit() {
        let wDelBsk = false;
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.customService.createSubject();
        this.bskMode = false;
        this.bskTypeMail = false;
        this.infosMailDisplay = null;
        this.actionGroup = false;
        this.reorgBsk = false;
        this.titleDetail = this.tools.setTitleDetail(this.srchMode, this.nbDoc);
        this.docVersion = signal([]);
        this.paramDetail = {
            initialize: false,
            rightService: this.rightService,
            infosMailDisplay: {},
            bskTypeMail: false,
            viewIndex: 0,
            bskMode: false,
            docInfos: [],
            docIndex: [],
            docIndexFiltered: [],
            docBasket: [],
            docAtf: [],
            displayBskVariableUpdate: false,
            listBskVariableUpdate: [],
            currentDocId: [],
            currentDocName: '',
            dockDyn: [],
            isLock: false,
            atfActions: this.atfActions,
            editorService: this.editorService,
            currentSelectedBsk: this.currentSelectedBsk,
            bskParamDock: {},
            nbZoneDisplay: {},
            dockoptions: {},
        }
        this.outComm = { comment: { comment: '' ,notif: { destUser: '', notifMess: '' }}, outComment: false };
        if (Object.keys(this.currentSelectedBsk).length !== 0) {
            this.bskMode = true;
            if (this.currentSelectedBsk.bskType === 'btMail') {
                this.bskTypeMail = true;
            }
            this.btnActionLabel = this.translate.instant('Validate');
            this.currentAction = 'validation';
            this.titleIndex = this.translate.instant('Ent_IdxBsk');
            this.titleDelete = this.translate.instant('Del_DocBsk');
            this.listBskVariableUpdate = [];
            this.bskVariableList = [];
            this.atfActions = this.currentSelectedBsk.bskAtfActions;
            if (this.currentSelectedBsk.bskType !== 'btAction' && this.currentSelectedBsk.bskRights.TDel === true) {
                wDelBsk = true;
            }            
            this.displayReorg = this.bskDockReorder;
        } else {
            this.btnActionLabel = this.translate.instant('Actions');
            this.currentAction = '';
            this.titleIndex = this.translate.instant('Ent_IdxDoc');
            this.titleDelete = this.translate.instant('Del_DocGed');
            this.atfActions = {
                atfRenaming: '',
                atfAllowAddFile: false,
                atfAllowDelete: false,
                atfAllowRename: false,
                atfAllowPrefixList: false,
                atfAllowConvertPdf: false,
                atfAllowSaveAs: false,
            };
            wDelBsk = true;
            this.displayReorg = this.srcDockReorder;
        }

        displayResultTools.setBtModeView(this.btGridActionList, this);
        displayResultTools.setBtGridAction(
            this.bskMode,
            wDelBsk,
            this.rightService,
            this.srchMode,
            this.btGridActionList,
            this
        );
        this.btGridActionList = displayResultTools.setTrackIdx(this.btGridActionList, this);
        this.infosMail = setInfosMail(true, '', this.translate);

        this.currentBskProperty = {
            bsk_docdate: '',
            bsk_docstatus: '',
            bsk_wkfid: '',
            bsk_mailaction: '',
            bsk_maillimit: '',
            bsk_mailurgent: '',
            bsk_mailconf: '',
        };

        this.currentUser = this.auth.getUser();
        this.visuGrid = 1;

        this.splitId = '';
        if (this.resultDisplay.length > 0) {
            this.splitId = this.resultDisplay[0].doc_docid;
            this.hasLock = displayResultTools.gethasLock(this.resultDisplay);
        }        
        this.viewIndex = 0;
        this.listColumnsWrk = [...this.listColumns];
        this.setModeView();
        this.setModeDetail(this.bskMode);
        this.panelService.init(this.bskMode, this.currentSelectedBsk);
        this.panelService.typeView = this.typeView;
        this.customService.subject.subscribe(async (data) => {
            await this.execGetAsyncInfosDoc(true);
            await this.documentDetail.traces.refresh();
            await this.documentDetail.commentaires.refresh();
        });

        this.waitIndex$ = new Subject();
        this.waitIndex$.subscribe({next:() => {
            this.displayIndexTransfert = true;
        }});
        if (this.addNotif === true) {
            if (this.api.userList.length === 0) {                
                this.getUserList();                
            } else {
                this.userList = this.api.userList;
            }
        }
        if (this.api.bskListAll.length === 0) {                
            this.getBskListAll();                
        }
    }

    private async getBskListAll() {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getallbsklist', ''));
            this.api.bskListAll = wRes.basketlist;
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            console.log('Error', error);
        }        
    }

    private async getUserList() {
        let wRes: any;
        this.userList = [];
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getalluserlist', ''));
            formatUserList(wRes, this.api.userList);
            this.userList = this.api.userList;            
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            console.log('Error', error);
        }        
    }

    private setModeView() {
        switch (this.internalPrefUsr.modeView) {
            case AvailableModeView[0].value: {
                this.modeView = 'G';
                break;
            }
            case AvailableModeView[1].value: {
                this.modeView = 'T';
                this.sizeThumb = 160;
                break;
            }
            case AvailableModeView[2].value: {
                this.modeView = 'T';
                this.sizeThumb = 320;
                break;
            }
            case AvailableModeView[3].value: {
                this.modeView = 'S';
                this.setViewSplit(this.modeView);
                break;
            }
            case AvailableModeView[4].value: {
                this.modeView = 'D';
                this.setViewSplit(this.modeView);
                break;
            }            
        }
    }

    private setModeDetail(bskMode) {
        const details = bskMode ? this.internalPrefUsr.bskTabDetail : this.internalPrefUsr.srcTabDetail;
        const availableDetails = bskMode ? AvailableBskTabDetail : AvailableSrcTabDetail;
    
        this.modeDetail = availableDetails.findIndex(detail => detail.value === details).toString();
        if (this.modeDetail = '-1') {
            this.modeDetail = '0';
        }
    }

    public ngAfterViewInit() {
        this.cd.detectChanges();
        this.autoClick();
    }

    public ngOnDestroy() {
        if (this.waitIndex$ && !this.waitIndex$.closed) {
            this.waitIndex$.unsubscribe();
        };
        this.unsubscribeComm();        
        this.customService.destroySubject();    
    }

    public ngOnChanges() {}

    public onClickReturn() {
        this.resetOutlet();
        this.onReturnResult.emit('');
    }

    public resetOutlet() {
        let wUrl = this.router.url;
        if (wUrl.substring(0, 19) === '/page-basket-detail') {
            this.router.navigate(['/page-basket-detail']);
        }
    }

    public autoClick() {
        if (this.autoDocId !== '') {
            this.verifyClickItem(this.autoDocId);
        }
    }
    private setActions() {
        this.currentVer = '0000';
        this.setActionCommon();
        if (!this.bskMode) {
            this.rightService.forceAction('TDInfo', true);
            this.setActionsGed();
            this.atfActions = displayResultTools.setActionsAtf(this.rightService);
        } else {
            this.rightService.setBskRights(this.currentSelectedBsk.bskRights);
            this.setActionsBsk();
        }
        displayResultTools.addNavigate(this.btDocActionList, this);
        this.btDocActionList = displayResultTools.setTrackIdx(this.btDocActionList, this);
    }

    private setActionsGed() {
        displayResultTools.addDwnlPdf(this.rightService, this.btDocActionList, this);
        if (this.isLock === false) {
            displayResultTools.setActionsGed(this.rightService, this.btDocActionList, this.srchMode, this);
            displayResultTools.setMenuImageGed(this.rightService, this.menuImage, this);
            displayResultTools.setModePdf(this.bskMode, this.currentSelectedBsk, this.btDocActionList, this);
        }
    }

    private setActionsBsk() {
        if (this.isLock === false) {
            this.rightService.forceAction('TDlOri', true);
            this.rightService.forceAction('TDlCpy', true);
            displayResultTools.addDwnlPdf(this.rightService, this.btDocActionList, this);
            displayResultTools.setActionsBsk(this.currentSelectedBsk, this.rightService, this.btDocActionList, this);
            displayResultTools.setMenuImageBsk(this.currentSelectedBsk, this.rightService, this.menuImage, this);
            displayResultTools.setModePdf(this.bskMode, this.currentSelectedBsk, this.btDocActionList, this);
        }
    }

    private setActionCommon() {
        this.btDocActionList = [];
        this.menuImage = [];
        // Force l'absence de signature graphique si pas d'image de signature issu de la config utilisateur
        if (this.userInfos.GraphicSign === false) {
            this.rightService.forceAction('TSign', false);
        }
        displayResultTools.setLock(this.currentLockUser, this.currentUser, this.btDocActionList, this);
    }

    public addItem(event) {
        this.dockStandardService.destTmp = JSON.parse(JSON.stringify(event.items));
        this.displayInfo = true;
    }

    public delItem(event) {
        this.dockStandardService.updateDestList(event.items);
    }

    public onChangeTab(event) {
        if (event !==0) {
            this.allowReorg = 'hidden';
            this.reorgBsk = false;
        } else {
            this.allowReorg = 'visible';
        }
    }

    private verifySelectedDocs(aCtrl) {
        if (aCtrl === false) {
            return true;
        }
        if (
            (this.modeView !== 'T' && this.displayresultgrid.selectedDocs.length === 0) ||
            (this.modeView === 'T' && this.dataView.getSelectedCount() === 0)
        ) {
            this._messageService.addWarnNoStick(this.translate.instant('NoDoc_Sel'));
            return false;
        }
        return true;
    }

    private prepareSelectedDocs() {
        let witem;
        this.selectedDocsExport.length = 0;
        if (this.modeView === 'T') {            
            this.dataView.selectedList.map((item) => {
                if (item.selected === true) {
                    witem = this.findInResult(item.doc_docid);
                    if (witem !== undefined) {
                        this.selectedDocsExport.push(witem);
                    }
                }
            });
        } else {
            this.displayresultgrid.selectedDocs.map((item) => {
                this.selectedDocsExport.push(item);
            });
        }
    }

    public onClickSaveInfoMail() {
        this.infosMail.mailActionLabel = this.translate.instant('Mail_' + this.infosMail.mailAction);
        this.dockStandardService.addDestList(this.infosMail);
        this.displayInfo = false;
    }

    private actionPdf(aAction, aStamp) {
        if (this.numPage < 1) {
            this._messageService.addWarnNoStick(this.translate.instant('Page_Not'));
            return;
        }
        this.currentActionDoc = aAction;
        this.currentStamp = aStamp;
        this.displayActions = true;
    }

    public onDel(event) {
        this.currentAction = event;
        this.displayDelDocs = true;
    }

    public onSendMail(event) {
        this.currentAction = event;
        this.displaySendMail = true;
    }

    public onVer(event) {
        this.currentAction = 'versionning';
        this.displayVersion = true;
    }

    public onCompose(event) {
        this.verifyAndSetTypeView();
        this.currentAction = 'compose';
        this.displayCompose = true;
    }

    public goTypeView0(event) {
        // Lecture pdf
        this.resetView(0);
    }

    public goTypeView1(event) {
        // Action pdf
        this.resetView(1);
    }

    public goTypeView2(event) {
        // Image pdf
        this.resetView(2);
    }

    private resetView(aView) {
        this.panelService.typeView = aView;
        this.paramDetail.dockBase = this.panelService.restorePanelDocks(this.paramDetail.dockBase);
        this.resetManagDock();
        this.typeView = aView;
        this.paramDetail.typeView = aView;
    }

    public goTypeView3(event) {
        // Affichage fenêtre pdf externe
        this.panelService.savePanelDocks(this.paramDetail.dockBase);
        this.paramDetail.dockBase = this.panelService.delDock(this.paramDetail.dockBase, 'dockVisu');
        localStorage.setItem('viewMode', this.typeView.toString())
        this.typeView = 3;
        this.paramDetail.typeView = 3;
        this.panelService.typeView = this.typeView;
        window.open('#/viewdoc','popup', 'width=800,height=1000');
        this.resetManagDock();
    }
    
    private resetManagDock() {
        if (this.paramDetail.typeView === 3) {
            this.manageDock(true);
            this.manageDock(false);        
        }
    }
    
    private setMove() {
        this.displayMove = true;        
    }

    public switchTransfert() {
        this.currentAction = 'move';
        if (this.dockMode === false) {
            this.setMove();
        }
    }

    public closeDialog(event) {
        this.currentAction = event;
    }

    public closeDelDocs(event) {
        this.displayDelDocs = false;
        this.currentAction = event;
    }

    private getBasketTransfert(aParam) {
        this.sendToBsk = aParam;
        if (this.bskMode) {
            this.setMove();
        } else {
            this.execGetBasketTransfert();
        }
    }

    private async execGetBasketTransfert() {
        let wRes: any;
        let wTranfert: any;
        wRes = false;
        try {
            wRes = await this.indexedDbService.getBasketListByUser();
            if (wRes.Status === 'ERROR') {
                throw new Error('Failed getBasketListByUser');
            }
        } catch (error) {
            console.log(error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        wTranfert = this.tools.getBasketTransfert(wRes.data, null, !this.bskMode, null, null, null);
        this.basketMoveAll = concatAllBasket(
            wTranfert.wBasketMailList,
            wTranfert.wBasketCollectList,
            wTranfert.wBasketInputList,
            wTranfert.wBasketPublishList,
        );
        this.setMove();
    }

    public selectBasketTransfert(event) {
        this.dockMode = false;
        this.verifyTransfert(event);
    }

    public selectBasketTransfertDock(event) {
        this.dockMode = true;
        this.sendToBsk = false;
        this.currentAtf = '';
        this.currentAction = 'validation';
        this.verifyTransfert(event);
    }
    
    private verifyTransfert(event) {
        this.currentTransfertBsk = setCurrentSelectedBsk(event, null);
        if (this.verifyExtensions(this.currentTransfertBsk) === false) {
            this._messageService.addWarnNoStick(this.translate.instant('Ext_Bsk'));
            return;
        }
        if (this.verifyComment() === true) {
            if (this.internalPrefUsr.displayConfirm === true) {
                this.setSubject();
                this.displayComm$.next();
                this.displayComm$.subscribe({next:() => {
                    this.displayComm = false;
                    this.displayIndexTrans();
                },
                    error: (err) => console.log(`Error occurred: ${err}`)
                });                
            } else {
                this.onClickSaveComm(true, false).then(() => 
                    this.displayIndexTrans()
                );
            }
        } else {
            this.displayIndexTrans();         
        }            
    }

    private displayIndexTrans() {
        if (this.verifyModified() === false) {
            this.displayIndexTransfert = true;
        } else {            
            if (this.internalPrefUsr.displayConfirm === true) {
                this.itemConfirm.confirmAction(
                    'warning',
                    this.translate.instant('Save_Idx'),
                    (accept) => {
                        this.updateIndex('', true);
                    },
                    (reject) => {
                        this.waitIndex$.next();
                    }
                );
            } else {
                this.updateIndex('', true);
            }
        }
    }

    public outComment($event) {
        this.outComm.comment.comment = $event.comment;
        this.outComm.outComment = $event.outComment;
    }

    private verifyComment() {
        return this.outComm.outComment;
    }

    public async onClickSaveComm($event, $doNext = true) {
        if ($event === true) {
            await this.execSaveComment(this.outComm.comment);
        } 
        this.outComm.outComment = false;
        this.outComm.comment.comment = '';
        this.displayComm = false;
        if ($doNext === true) {            
            this.displayComm$.next();
        }
    }

    private setSubject() {
        this.displayComm = true;
        this.displayComm$ = new Subject();
    }

    private unsubscribeComm() {
        if (this.displayComm$ && !this.displayComm$.closed) {
            this.displayComm$.unsubscribe();
        };
    }

    private verifyExtensions(aCurrentTransfertBsk) {
        let wExtOk = true;
        let wListExt = new Array();
        wListExt = getBskAllowExt(aCurrentTransfertBsk);
        if (wListExt.length === 0) {
            return wExtOk;
        }

        for (const item of this.docIdList) {
            if (wListExt.indexOf(getFileExt(item.doc_name)) === -1) {
                wExtOk = false;
                break;
            }
        }
        return wExtOk;
    }

    private setBskProperty(aBskType, aData) {
        this.infosMail = setInfosMail(true, '', this.translate);
        this.bskDocDate = getDateInternal(aData.bsk_docdate);
        if (aBskType === 'btMail') {
            this.infosMail = setInfosMail(false, aData, this.translate);
            this.infosMailDisplay = this.infosMail;
            this.paramDetail.infosMailDisplay = this.infosMailDisplay;
        } else {
            this.infosMail.status = aData.bsk_docstatus;
        }
    }

    public manageDock(reorgBsk) {
        this.documentDetail.options.draggable.enabled = reorgBsk;
        this.documentDetail.options.resizable.enabled = reorgBsk;
        if (this.documentDetail.options.api && this.documentDetail.options.api.optionsChanged) {
            this.documentDetail.options.api.optionsChanged();
        }
    }

    public async saveDock($event) {
        let wRes: any;
        let wTab = [];
        let wTabBase = [];
        let wTabRes = [];
        // Maj des docks
        if ($event === true) {
            wRes = await this.panelService.saveDock(this.rightService, $event, this.documentDetail, this.currentSelectedBsk, this.basketMoveAll);
            if (wRes === false) {
                this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            }
        } else {
            // Reset des docks
            wRes = await this.panelService.resetDocks();
            if (wRes.success === false) {
                this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
                wTab = this.panelService.resetPanel(this.rightService, this.bskTypeMail, this.infosMailDisplay, 
                    this.currentSelectedBsk, this.displayBskVariableUpdate, this.currentSelectedBsk.bskDockDyn, this.basketMoveAll);
            } else {
                if (wRes.details === true) {
                    // Repositionnement des docks
                    wTabRes = JSON.parse(wRes.docks);
                    wTab = this.panelService.resetPosition(wTabRes, this.rightService, this.bskTypeMail, this.infosMailDisplay, this.currentSelectedBsk, this.displayBskVariableUpdate, this.currentSelectedBsk.bskDockDyn, this.basketMoveAll);
                } else {
                    wTab = this.panelService.resetPanel(this.rightService, this.bskTypeMail, this.infosMailDisplay, 
                        this.currentSelectedBsk, this.displayBskVariableUpdate, this.currentSelectedBsk.bskDockDyn, this.basketMoveAll);                    
                }
            }
            this.paramDetail.dockBase = [...wTab.map(x => ({ ...x }))];
            this.panelService.storeAfterReset(JSON.stringify(this.paramDetail.dockBase));
        }
        this.paramDetail.reorgBsk = false;
        this.reorgBsk = false;
        this.manageDock(false);
    }

    public async onClickRename() {
        let wRes: any;
        wRes = false;
        this.newDocName = this.newDocName.trimStart();
        if (this.newDocName.trim() === '' || this.newDocName.trim() === getFileNameWithoutExt(this.currentDocName)) {
            return;
        }
        // Verif lock
        wRes = await this.documentService.execVerifyCheckOut(this.auth.getUser());
        if (wRes === true) {
            await this.execClickRename();
        }
    }

    private async execClickRename() {
        let wError = 0;
        let wRes: any;
        let wName: string;
        wName = this.newDocName;
        wRes = await this.documentService.rename(this.newDocName);
        if (wRes === false) {
            wError++;
        }
        wRes = await this.execGetAsyncInfosDoc(true);
        if (wRes === false) {
            wError++;
        } else {
            wName = getProperty(this.docInfos, 'Name');
            this.refreshDataAfterUpdate('rename', wName, this.currentDocId);
            this.newDocName = wName;
        }
        this.displayRename = false;
        this.displayMessage(wError === 0);
    }

    public async saveComment(aComment) {
        this.currentAction = 'comment';
        await this.execSaveComment(aComment);
    }

    private async execSaveComment(aComment) {
        let wRes: any;
        wRes = false;
        // Verif lock
        wRes = await this.documentService.execVerifyCheckOut(this.auth.getUser());        
        if (wRes === true) {
            await this.execClickSaveComment(aComment);            
        }
    }

    private async execClickSaveComment(aComment) {
        let wError = 0;
        let wRes: any;
        aComment.comment = replEmoji(aComment.comment, this._messageService, this.translate);
        this.documentService.comment = aComment.comment;
        wRes = await this.documentService.saveComment(this.userInfos);
        if (wRes === false) {
            wError++;
        }
        this.outComm.outComment = false;
        this.outComm.comment.comment = '';
        try {        
            if (this.documentDetail.traces) {
                await this.documentDetail.traces.refresh();
            }
            if (this.documentDetail.commentaires) {
                await this.documentDetail.commentaires.refresh();
            }
        } catch (error) {
            wError++;
        }

        if (aComment.notif.destUser.length !== 0) {
            const wData = {                
                data: this.notifService.getFromUser(this.isAdmin, this.userList, this.currentUser),
                destuser: aComment.notif.destUser,
                docid: this.currentDocId,
                fromUser: this.currentUser,
                typeNotif: 4
            }
            wRes = await this.notifService.addNotification(wData);
            if (wRes.Status === 'ERROR') {
                wError++;
            }
        }
        this.displayMessage(wError === 0);
    }
    
    public async updateIndex(aSens, aDoNext = true) {
        let wRes: any;
        let wResPattern: any;
        wResPattern = this.verifyIndex();
        if (wResPattern.pattern === false) {
            return;
        }
        wRes = await this.onClickSaveIndex(wResPattern.varListUpdate);
        if (this.documentDetail.traces) {
            await this.documentDetail.traces.refresh();
        }
        if (aSens !== '') {
            this.goNextOrPrevDoc(aSens);
        }
        if (aDoNext === true) {     
            this.waitIndex$.next();
        }
    }
    private verifyIndex() {
        let wPattern = true;
        let wMess = '';
        let wVarListUpdate = new Array();
        wVarListUpdate = [];

        if (this.bskMode === true) {
            wVarListUpdate = this.editorService.setValueForUpdate(this.listBskVariableUpdate);
            wMess = this.editorService.verifyPattern(wVarListUpdate);
        } else {
            wMess = this.editorService.verifyPattern(this.listBskVariableUpdate);
        }
        if (wMess !== '') {
            this._messageService.addErrorNoStick(this.translate.instant('Ent_NotValid') + '\n' + wMess);
            wPattern = false;              
        }
        return {
            pattern: wPattern,
            varListUpdate: wVarListUpdate
        }  
    }

    public async onClickSaveIndex(aVarListUpdate) {
        let wRes: any;
        wRes = false;
        // Verif lock
        wRes = await this.documentService.execVerifyCheckOut(this.auth.getUser());
        if (wRes === true) {
            wRes = await this.execSaveIndex(aVarListUpdate);
            this.displayMessage(wRes);
        }
    }

    private async execSaveIndex(aVarListUpdate) {
        let wError = 0;
        let wRes: any;
        wRes = false;
        if (this.bskMode === true) {
            wRes = await this.documentService.saveIndex(aVarListUpdate);
        } else {
            wRes = await this.documentService.saveIndex(this.listBskVariableUpdate);
        }
        if (wRes === false) {
            wError++;
        }
        wRes = await this.execGetAsyncInfosDoc(true);
        if (wRes === false) {
            wError++;
        } 
        return wError === 0;
    }

    // Maj tableau résultat
    private updateResultDisplay(adocid, aResultDisplay, aListColumns, aVarList) {
        let windex = -1;
        let wRes: any;
        if (aVarList.Variable !== undefined) {
            windex = this.getIndexFromResDisp(adocid);
            if (windex !== -1) {
                aListColumns.forEach((col) => {
                    wRes = aVarList.Variable.find((item) => item.Name === col.field);
                    if (wRes !== undefined) {
                        if (col.type === 'DateTime') {
                            aResultDisplay[windex][col.field] = wRes.value + '|' + dateFormat(wRes.value, 'dd/MM/yyyy');
                        } else {
                            aResultDisplay[windex][col.field] = wRes.value;
                        }
                    }
                });
            }
        }
        return aResultDisplay;
    }

    public async onClickSaveMail(mailInfo) {
        let wRes: any;
        // Verif lock
        wRes = await this.documentService.execVerifyCheckOut(this.auth.getUser());        
        if (wRes === true) {
            await this.execClickSaveMail(mailInfo);
        }
    }

    private async execClickSaveMail(event) {
        let wRes: any;
        wRes = false;
        this.infosMail = event;
        this.infosMail.mailActionLabel =  this.translate.instant('Mail_' + this.infosMail.mailAction);
        let wInfoMail = displayResultTools.setActionMail(this.infosMail, this.currentSelectedBsk);
        this.infosMail.mailDelay = getDelay(wInfoMail.mailLimit, this.delay);
        this.documentService.currentDocName = this.currentDocName;
        wRes = await this.documentService.saveMail(wInfoMail);
        this.refresh(this.documentService.bskStatus, 'savemail', this.documentService.reqBsk, this.currentDocId);
        this.displayMessage(wRes);
    }

    private displayMessage(aRes) {        
        if (aRes) {
            this._messageService.addSuccess(this.translate.instant('Update_OK'));
        } else {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
    }

    public onClickDeleteDoc(aParam) {
        let wdocidList = this.commonRefresh(aParam);
        for (const item of wdocidList) {
            this.refreshDataAfterUpdate('delete', '', item);
        }
        if ((this.modeView !=='T' && this.modeView !=='G' ) && this.resultDisplay.length > 0) {            
            // Repositionnement du pdf sur vue split/thumb
            this.curPage = this.displayresultgrid.curPage;
            this.currentDocId = undefined;   // pour forcer la lecture
            this.splitId = this.resultDisplay[this.displayresultgrid.curIndex].doc_docid;
            this.setViewSplit('D');
        }
        this.goReturnList('delete');
    }

    public onClickChangeDoc(aParam) {
        this.displayChangeDoc = false;
        let wdocidList = this.commonRefresh(aParam);
        for (const item of wdocidList) {
            this.refreshDataAfterUpdate('changedoc', item, item.docId);
        }
        this.goReturnList('changedoc');
    }

    private commonRefresh(aParam) {
        if (aParam.mode === true) {
            this.resetOutlet();
        }
        this.visuGrid = 1;
        let wdocidList = JSON.parse(aParam.docidList);
        this.nbDoc = this.nbDoc - wdocidList.length;
        this.titleDetail = this.tools.setTitleDetail(this.srchMode, this.nbDoc);
        return wdocidList;
    }

    private updateVarList(aVariableList) {
        switch (this.currentSelectedBsk.bskTypeDock) {
            case 'InvoiceValidation': {
                return aVariableList.concat(this.bskParamDock.varList);
            }
            case 'MailDispatching': {
                this.dockStandardService.getRecipientList(this.bskParamDock.varList);
                return aVariableList.concat(this.bskParamDock.varList);
            }
            case 'MailValidation': {
                return aVariableList.concat(this.bskParamDock.varList);
            }
            default: {
                return aVariableList.concat([]);
            }
        }
    }

    private verifyRequiredComment(aComment, aRequiredComment) {
        if (aRequiredComment === true && aComment.trim() === '') {            
            this._messageService.addErrorNoStick(this.translate.instant('Com_Req'));
            return false;
        }
        return true;
    }

    public async actionTrans(event) {        
        this.displayIndexTransfert = false;
        this.unsubscribeComm();
        this.displayMove = false;
        this.nbDoc = event.nbDoc;
        this.sendToBsk = false;

        this.loadingService.resetLoader()

        if (event.action === 'mailaddbsk' || event.action === 'addbsk') {
            this.goReturnList(event.action);
            return;
        }

        for (const wEvent of event.listUpdate) {
            this.refresh(wEvent.res, event.action, wEvent.request, wEvent.docId);
        }
        if (event.action === 'mailmove' || event.action === 'move') {
            this.visuGrid = 1;
            this.titleDetail = this.tools.setTitleDetail(this.srchMode, this.nbDoc);
        }
        if ((event.action === 'mailcopy' || event.action === 'copy') && this.actionGroup === false) {
            await this.execGetAsyncInfosDoc(true);
        }
        this.goReturnList(event.action);
    }

    private async execGetAsyncInfosDoc(aUpdateResult) {
        let wRes;
        try {
            wRes = await lastValueFrom(this.documentService.readInfosDoc(false, this.indexedDbService.variableStorage));
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return false;
        }
        this.setBaseInfos(wRes, this.currentDocId);
        this.setParamDetail();
        if (aUpdateResult === true) {
            this.resultDisplay = this.updateResultDisplay(
                this.currentDocId,
                this.resultDisplay,
                this.listColumns,
                wRes.getIndexDoc.VariableList
            );
        }
    }

    private goReturnList(aAction) {
        let wAction = 'move';
        // Mode bannette ?
        if (this.bskMode === true) {
            wAction = aAction;
        }
        this.onAction.emit(wAction);
        if (this.nbDoc === 0) {
            if (this.bskMode === true) {
                this.router.navigate(['/page-basket-list']);
            } else {
                this.onReturnResult.emit('empty');
            }
        } else {
            if (this.actionGroup === false) {
                if (aAction === 'validate' || aAction === 'mailmove' || aAction === 'move') {
                    if (this.internalPrefUsr.bskNextVal === true) {
                        this.nextDoc();            
                    }
                }
            }
        }
    }

    public onApplyAction(action) {
        let wVarListUpdate = new Array();
        let wInfoMail;
        wVarListUpdate = [];
        wVarListUpdate = this.editorService.setValueForUpdate(this.listBskVariableUpdate);
        if (this.checkCtrlVar(action, this.currentSelectedBsk) === true) {
            if (verifyDataEnter(wVarListUpdate, this.editorService, this._messageService, this.translate) === false) {
                return;
            }
        }
        if (this.currentSelectedBsk.bskType === 'btMail') {
            wInfoMail = displayResultTools.setActionMail(this.infosMail, this.currentSelectedBsk);
            this.execValid('validmail', wInfoMail, wVarListUpdate);
        } else {
            this.applyAction(action, wVarListUpdate);
        }
    }

    private checkCtrlVar(aAction, aCurrentSelectedBsk) {
        let wRes = true;
        let wAction: number;
        if (aCurrentSelectedBsk.bskType === 'btAction') {
            wAction = parseInt(aAction);
            // pas de control sur les variables requises
            if (aCurrentSelectedBsk.bskbuttonList[wAction].NoVariablesRequired === true) {
                wRes = false;
            }
        }
        return wRes;
    }

    private applyAction(action, aVariableList) {
        let wAction: number;
        if (this.currentSelectedBsk.bskType === 'btAction') {
            wAction = parseInt(action);
            if (
                this.verifyRequiredComment(
                    this.documentDetail.commentaires.comment,
                    this.currentSelectedBsk.bskbuttonList[wAction].RequiredComment
                ) === false
            ) {
                return;
            }
            this.applyBskAction(wAction, aVariableList);
        } else {
            this.applyActionOther(aVariableList);
        }
    }

    private applyActionOther(aVariableList) {
        let wInfoMail;
        if (
            this.verifyRequiredComment(
                this.documentDetail.commentaires.comment,
                this.currentSelectedBsk.bskRequiredComment
            ) === false
        ) {
            return;
        }
        if (this.currentSelectedBsk.bskTypeDock === 'MailValidation') {
            this.applyBskAction(-1, aVariableList);
        } else {
            wInfoMail = this.formatRequestTools.bskValid(this.currentSelectedBsk);
            this.execValid('validbsk', wInfoMail, aVariableList);
        }
    }

    private applyBskAction(action, aVariableList) {
        let wlistIndex = new Array();
        let wInfoMail;
        wInfoMail = this.formatRequestTools.bskAction(this.currentSelectedBsk, this.currentBskProperty, action);
        if (
            ['InvoiceValidation', 'MailDispatching', 'MailValidation', 'MailReordering'].indexOf(
                this.currentSelectedBsk.bskTypeDock
            ) > -1
        ) {
            wlistIndex = this.updateVarList(aVariableList);
            if (action !== -1) {
                if (this.currentSelectedBsk.bskbuttonList[action].NoVariablesRequired === false) {
                    if (verifyRequiredIndex(wlistIndex, this.editorService, this._messageService, this.translate) === false) {
                        return;
                    }
                    if (this.verifyRequiredRecipient() === false) {
                        return;
                    }
                }
            } else {
                if (verifyDataEnter(wlistIndex, this.editorService, this._messageService, this.translate) === false) {
                    return;
                }
            }
            this.execValid('validbskaction', wInfoMail, wlistIndex);
        } else {
            this.execValid('validbskaction', wInfoMail, aVariableList);
        }
    }

    private verifyRequiredRecipient() {
        var wRes = true;
        if (['MailDispatching'].indexOf(this.currentSelectedBsk.bskTypeDock) > -1) {
            if (this.bskParamDock.trgList.length <= 0) {
                this._messageService.addErrorNoStick(this.translate.instant('Dst_Req'));
                return false;
            }
        }
        return wRes;
    }

    private async execValid(action, aInfoMail, listVariable) {
        this.documentService.currentSelectedBsk = this.currentSelectedBsk;
        if (this.paramDetail.rightService.typeAction.TDCom === true) {
            this.documentService.comment = this.documentDetail.commentaires.comment;
        }
        this.documentService.currentDocName = this.currentDocName;
        await this.documentService.execValid(action, aInfoMail, listVariable, this.userInfos);
        this.outComm.outComment = false;
        this.outComm.comment.comment = '';
        this.refresh(this.documentService.bskStatus, action, this.documentService.reqBsk, this.currentDocId);
        this.visuGrid = 1;
        if (this.documentService.nbError === 0) {
            this._messageService.addSuccess(this.translate.instant('Valid_OK'));
            this.nbDoc--;
            this.titleDetail = this.tools.setTitleDetail(this.srchMode, this.nbDoc);
            this.goReturnList('validate');
        } else {
            this._messageService.addErrorMsg(this.translate.instant('Valid_KO'));
        }
    }

    private refresh(aRes, aAction, aRequest, aDocId) {
        switch (aAction) {
            case 'validmail':
            case 'validbsk':
            case 'validbskaction':
            case 'delete':
            case 'mailmove':
            case 'move': {
                this.resetOutlet();
                break;
            }
        }
        if (aRes === true) {
            this.refreshDataAfterUpdate(aAction, aRequest, aDocId);
        }
    }

    private refreshDataAfterUpdate(aAction, aRequest, aDocId) {
        let windex = -1;
        switch (aAction) {
            case 'savemail': {
                windex = this.getIndexFromResDisp(aDocId);
                if (windex !== -1) {
                    this.resultDisplay[windex].bsk_docstatus = decodeUtf8(aRequest.ParamList.DocStatus);
                    this.resultDisplay[windex].bsk_mailaction = aRequest.ParamList.MailAction.toString();
                    this.resultDisplay[windex].bsk_mailactionLabel = this.translate.instant('Mail_' + aRequest.ParamList.MailAction);
                    this.resultDisplay[windex].bsk_mailurgent = aRequest.ParamList.MailUrgent === true ? '1' : '0';
                    this.resultDisplay[windex].bsk_mailconf = aRequest.ParamList.MailConfidential === true ? '1' : '0';
                    if (aRequest.ParamList.MailLimit === '' || aRequest.ParamList.MailLimit === '|') {
                        this.resultDisplay[windex].bsk_maillimit = '';
                    } else {
                        this.resultDisplay[windex].bsk_maillimit =
                            aRequest.ParamList.MailLimit + '|' + dateFormat(aRequest.ParamList.MailLimit, 'dd/MM/yyyy');
                    }
                    this.resultDisplay[windex].bsk_delay = getDelay(aRequest.ParamList.MailLimit, this.delay);
                }
                this.currentBskProperty.bsk_docstatus = decodeUtf8(aRequest.ParamList.DocStatus);
                this.currentBskProperty.bsk_mailaction = aRequest.ParamList.MailAction.toString();
                this.currentBskProperty.bsk_maillimit = aRequest.ParamList.MailLimit;
                this.currentBskProperty.bsk_mailurgent = aRequest.ParamList.MailUrgent === true ? '1' : '0';
                this.currentBskProperty.bsk_mailconf = aRequest.ParamList.MailConfidential === true ? '1' : '0';
                this.infosMailDisplay = this.infosMail;
                this.updataDocBasket(aRequest.ParamList.DstBasketName,this.currentBskProperty);
                break;
            }
            case 'mailinsert':
            case 'insert': {
                this.docBasket.push({
                    Name: aRequest.ParamList.DstBasketName,
                    Label: aRequest.ParamList.DstBasketName,
                });
                break;
            }
            case 'deleteged':
            case 'delete':
            case 'move':
            case 'mailmove':
            case 'validmail':
            case 'validbsk':
            case 'validbskaction': {
                this.resultDisplay = this.resultDisplay.filter((item) => {
                    return item.doc_docid !== aDocId;
                });
                // Reset de la liste des éléments selectionnées après suppression
                if (this.modeView === 'T') { // si on est en mode thumbnail, on reset la liste des thumbnail sélectionnées
                    this.dataView.selectedList = this.dataView.selectedList.filter(item => !item.selected);
                }
                this.displayresultgrid.posFirstIndex();
                break;
            }
            case 'lock':
            case 'unLock': {
                this.hasLock = this.updateLockUnLlock(aDocId, aAction);
                break;
            }
            case 'changedoc': {
                windex = this.getIndexFromResDisp(aDocId);
                if (windex !== -1) {
                    this.resultDisplay[windex].doc_root = aRequest.infos.root;
                    this.resultDisplay[windex].doc_path = aRequest.infos.path;
                    if (aRequest.infos.name !== '') {
                        this.resultDisplay[windex].doc_name = aRequest.infos.name + this.resultDisplay[windex].doc_ext;
                    }
                }
                break;
            }
            case 'rename': {
                windex = this.getIndexFromResDisp(aDocId);
                if (windex !== -1) {
                    this.resultDisplay[windex].doc_name = aRequest + this.resultDisplay[windex].doc_ext;
                }
                break;
            }
        }
        // this.setParamDetail();
        this.selectedDocsExport.length = 0;
        this.displayresultgrid.selectedDocs.length = 0;
    }

    private updataDocBasket(aBskName, aCurrentBskProperty) {
        let wIndex = -1;
        wIndex = this.docBasket.findIndex((item) => item.name === aBskName);
        if (wIndex !== -1) {
            this.docBasket[wIndex].status = aCurrentBskProperty.bsk_docstatus;
            this.docBasket[wIndex].value = aCurrentBskProperty.bsk_docstatus;
            this.docBasket[wIndex].action = aCurrentBskProperty.bsk_mailaction;
        }
    }

    private updateLockUnLlock(aDocId, aAction) {
        let wRes: boolean;
        let windex = -1;
        let wValue = '';
        wRes = false;
        windex = this.getIndexFromResDisp(aDocId);
        if (windex !== -1) {
            if (aAction === 'lock') {
                wValue = this.currentUser;
            }
            this.resultDisplay[windex].doc_checkoutuser = wValue;
        }
        if (this.resultDisplay.length > 0) {
            wRes = displayResultTools.gethasLock(this.resultDisplay);
        }
        return wRes;
    }

    private getIndexFromResDisp(aDocId) {
        let windex = -1;
        return (windex = this.resultDisplay.findIndex((item) => {
            return item.doc_docid === aDocId;
        }));
    }

    public onLockUnlock() {
        let wActionLock = this.getMsgActionLock(this.currentLockUser, this.lockDate);
        this.lockHeader = wActionLock.header;
        this.itemConfirm.confirmAction('lock', wActionLock.msg, (accept) => {
            this.execLockUnlock(wActionLock.action);
        });
    }

    private getMsgActionLock(aCurrentLockUser, aLockDate) {
        this.translate.instant('Valid_KO')
        if (aCurrentLockUser === '') {
            return {
                header: this.translate.instant('Conf'),
                action: 'lock',
                msg: this.translate.instant('Lock_Doc'),
            };
        } else {
            return {
                header: this.translate.instant('UnLock_Doc'),
                action: 'unLock',
                msg: this.translate.instant('Lock_Usr', {user: aCurrentLockUser , date: aLockDate}),
            };
        }
    }

    private async execLockUnlock(aAction) {
        let wRes: any;
        let wError = 0;
        wRes = await this.documentService.lockUnlock(aAction, this.userInfos);
        if (wRes === false) {
            wError++;
        }
        wRes = await this.execGetAsyncInfosDoc(false);
        if (wRes === false) {
            wError++;
        } else {
            this.refreshDataAfterUpdate(aAction, '', this.currentDocId);
            this.btDocActionList[0].class = displayResultTools.getLockClass(this.currentLockUser, this.currentUser);
            this.setActions();            
        }
        if (wError !== 0) {
            this._messageService.addErrorMsg(this.translate.instant('Lock_Err'));
        }
    }

    public async onDownload(atype) {
        let wAction: string = '';
        this.downloadService.setDocId(this.currentDocId);
        if (atype === 'copy') {
            wAction = 'getdocumentcopy';
        } else {
            wAction = 'getdocument';
        }        
        await this.downloadService.downloadDocument(wAction, this.docInfos);
    }

    public onClickMainImg(event) {
        this.setDimAndPos(event);
        this.numPage = 1;
    }

    public onClickImg(event) {
        this.originClick = 'L';
        this.clickItem(event);
    }

    public clickcolpdf(data) {
        this.originClick = '';
        this.splitId = data.docId;
        this.setViewSplit(data.modeView);
    }
    
    public clickline(adocid) {
        this.originClick = 'L';
        this.verifyClickItem(adocid);
    }

    public onRightClick(event) {
        setToolbar();
        let wPage = this.documentDetail.currentPage;
        this.setDimAndPos(event);
        this.numPage = wPage;
    }

    private setDimAndPos(event) {
        this.pos.x = event.offsetX;
        this.pos.y = event.offsetY;
        this.dimension.x = event.target.clientWidth;
        this.dimension.y = event.target.clientHeight;
    }

    public clickItem(event) {
        this.showModal(false)
        this.initInfosdoc();
        this.actionGroup = false;
        this.reorgBsk = false;
        this.currentDocId = event.data.doc_docid;
        this.documentService.setDocId(this.currentDocId);
        this.currentDocName = event.data.doc_name;
        this.newDocName = getFileNameWithoutExt(event.data.doc_name);
        this.getInfosDoc(this.currentDocId, true, event, this.currentDocName);
    }

    private setDocIdList(aDocId, aDocName) {
        this.docIdList.length = 0;
        this.docIdList.push({ doc_docid: aDocId, doc_name: aDocName });
    }

    private setcurrentBskProperty(aBskType, aData) {
        let wResult;
        if (!aBskType) {
            return;
        }
        const type = {
            btMail: displayResultTools.bskPropertyMail,
            btCollect: displayResultTools.bskProperty,
            btPublish: displayResultTools.bskProperty,
            btInput: displayResultTools.bskProperty,
            btOutput: displayResultTools.bskProperty,
            btSystem: displayResultTools.bskProperty,
            btAction: displayResultTools.bskPropertyAction,
        };

        if (type[aBskType]) {
            wResult = type[aBskType](aData);
        }
        return wResult;
    }

    public onClickExport(aCtrl) {
        if (!this.verifySelectedDocs(aCtrl)) {
            return;
        }
        this.prepareSelectedDocs();
        this.displayExport = true;
    }

    public onClickExportXlsx(aCtrl) {
        let wExport = [];
        if (!this.verifySelectedDocs(aCtrl)) {
            return;
        }
        this.prepareSelectedDocs();
        wExport = prepareExportExcel(this.listColumns, this.selectedDocsExport);
        this.exportExcel(this.srchMode, wExport);
    }

    private async exportExcel(aName, wExport) {
        await this.downloadService.exportExcel(getExportFileName(aName), wExport);
    }

    public onClickMoveDoc(aCtrl) {
        if (!this.verifySelectedDocs(aCtrl)) {
            return;
        }
        this.prepareSelectedDocs();
        this.displayChangeDoc = true;
    }

    public onRenameDoc(event) {
        this.currentAction = event;
        if (this.newDocName === '') {
            this.newDocName = getFileNameWithoutExt(this.currentDocName);
        }
        this.displayRename = true;
    }

    public onClickSendMail(event) {
        if (!this.verifySelectedDocs(event)) {
            return;
        }
        this.prepareSelectedDocs();
        this.displaySendMail = true;
    }

    public onClickStat(event) {
        this.displayStat = true;
    }

    public onClickDelBsk(event) {
        if (!this.verifySelectedDocs(event)) {
            return;
        }
        this.prepareSelectedDocs();
        this.actionGroup = true;
        this.displayDelDocs = true;
    }

    public onClickTransBsk(event) {
        let witem;
        if (!this.verifySelectedDocs(event)) {
            return;
        }
        this.docIdList.length = 0;
        if (this.modeView !== 'T') {
            this.displayresultgrid.selectedDocs.map((item) => {
                this.docIdList.push({ doc_docid: item.doc_docid, doc_name: item.doc_name });
            });
        } else {
            this.dataView.selectedList.map((item) => {
                if (item.selected === true) {
                    witem = this.findInResult(item.doc_docid);
                    if (witem !== undefined) {
                        this.docIdList.push({ doc_docid: item.doc_docid, doc_name: item.doc_name });
                    }
                }
            });
        }

        this.actionGroup = true;
        // this.displayMove = true;
        this.currentAction = 'move';
        this.getBasketTransfert(false);
    }

    public closeStat() {
        this.displayStat = false;
    }

    public closeChangeDoc() {
        this.displayChangeDoc = false;
    }

    public closeRename() {
        this.displayRename = false;
    }

    public closeExport() {
        this.displayExport = false;
    }

    public closeSendMail() {
        this.displaySendMail = false;
    }

    public closeMove(event) {
        this.currentAction = event;
        this.displayMove = false;
    }

    public closeTrans(event) {
        if (this.dockMode === true) {
            this.currentAction = 'validation';
        } else {
            this.currentAction = event;
        }
        this.displayIndexTransfert = false;
        this.unsubscribeComm();
    }

    public closeVersion(event) {
        if (event === 'add') {
            this.refreshVersion(this.currentDocId);
        }
        this.displayVersion = false;
    }

    public closeCompose(event) {
        this.displayCompose = false;
        if (event === 'composeSuccess') {
            this.setPathPdfImg(this.currentDocId);
            this.paramDetail.pathPdf = this.pathPdf;
            this.paramDetail.pathImg = this.pathImg;            
        }
    }

    public closeActions(event) {
        this.displayActions = false;
    }

    public refreshActions(event) {
        this.refreshComTrace();
    }

    public async refreshVersion(adocid) {
        let wRes: any;
        wRes = await this.execGetAsyncInfosDoc(false);
        if (wRes === false) {
            return;
        }
        await this.documentDetail.versionlist.refresh();
        if (this.documentDetail.traces) {            
            await this.documentDetail.traces.refresh();
        }
        this.setPathPdfImg(adocid);
    }

    public refreshAtf(event) {
        this.currentAtf = '';
        if (event.action === 'trs') {
            this.actionGroup = false;
            this.currentAction = 'atftobsk';
            this.sendToBsk = true;
            this.currentAtf = event.data.AtfName;
            this.getBasketTransfert(true);
        } else {
            this.atfAction(event);
        }
    }
    
    public async clickAtfGed(event) {
        await this.getContentUrl(event);
    }

    private async getContentUrl(atfFile) {
        let wUrl: string = '';
        let wRequest: string = '';
        let wSize: any;
        this.downloadService.setDocId(this.currentDocId);        
        await this.downloadService.getContentUrl(atfFile.Name);
        this.downloadService.getStatus();
        if (this.downloadService.getStatus() === false) {
            return;
        }
        wUrl = this.downloadService.getUrl();
        if (wUrl !== '') {
            console.log('wUrl', wUrl);
            window.open(wUrl,'popup', 'width=800,height=1000');
            return;
        }
        wRequest = this.downloadService.getRequest();
        if (wRequest !== '') {
            await this.downloadService.getUrlRequest(this.docIndex);
            if (this.downloadService.getStatus() === false) {
                return;
            }
            wSize = this.downloadService.getWinSize();
            window.open(this.downloadService.getUrl(),'popup', 'width='+wSize.width+',height='+wSize.height);
        }
    }

    private atfAction(event) {
        let windex = -1;
        if (event.info !== undefined) {
            if (
                event.info.listFileSuccess + event.info.listFileError === event.info.listFile &&
                event.info.cancelAdd === false &&
                event.info.uploadCountSuccess !== 0
            ) {
                this._messageService.addSuccess(this.translate.instant('File_Send', {nbFile: event.info.uploadCountSuccess}));
            }
        }
        let wResult = [];
        const type = {
            add: displayResultTools.atfAdd,
            del: displayResultTools.atfDel,
            cnv: displayResultTools.atfRen,
            ren: displayResultTools.atfRen,
        };
    
        if (type[event.action]) {
            wResult = type[event.action](event, this.docAtf);
        }
        this.docAtf = [...wResult];
        this.documentDetail.paramDetail.docAtf = this.docAtf;
    
        windex = this.getIndexFromResDisp(this.currentDocId);
        if (windex !== -1) {
            const typeUpdate = {
                add: displayResultTools.updateAtf,
                del: displayResultTools.updateAtf,
            };
            if (typeUpdate[event.action]) {
                this.resultDisplay[windex].doc_atfcount = typeUpdate[event.action](
                    event.action,
                    this.resultDisplay[windex].doc_atfcount
                );
            }
        }
    }

    public refreshVer(aName) {
        this.documentDetail.versionlist.refreshVer(aName);
    }

    public viewVer(event) {
        if (this.currentVer === event.value) {
            this.setShowVer(this.currentVer, !event.showVer);
            this.currentVer = '0000';            
            this.refreshComTrace();
            this.allowReorg = 'visible';
        } else {
            this.setShowVer(this.currentVer, true);
            this.setShowVer(event.value, false);
            this.getInfosDocVer(event.Docid);  
            this.currentVer = event.value;
        }
    }
        
    private setShowVer(aVer: any, aValue: any) {
        this.docVersion().forEach(item => {
            if (item.value === aVer) {
                item.showVer = aValue;
            }
        });
    }
     
    public readVer(event) {
        this.docVersion = event;
    }

    private async refreshComTrace() {
        let windex = -1;
        windex = this.getIndexFromResDisp(this.currentDocId);
        if (windex !== -1) {            
            await this.getInfosDoc(this.currentDocId, true, {data: this.resultDisplay[windex]}, this.currentDocName);
            if (this.documentDetail.traces) {
                await this.documentDetail.traces.refresh();
            }
        }
    }

    public onClickAddBasket(aCtrl) {
        if (!this.verifySelectedDocs(aCtrl)) {
            return;
        }
        if (this.srchMode !== reqBas) {
            this.updateBasket('add');
            this._messageService.addInfo(this.translate.instant('Add_OK'));
        } else {
            this.updateBasket('del');
            this.nbDoc = this.resultDisplay.length;
            this.titleDetail = this.tools.setTitleDetail(this.srchMode, this.nbDoc);
            this.onAction.emit('del');
        }
    }

    private updateBasket(aAction) {
        if (this.modeView === 'T') {
            this.updateBasketThumb(aAction);
        } else {
            this.updateBasketGrid(aAction);
        }       
    }

    private updateBasketGrid(aAction) {
        this.displayresultgrid.selectedDocs.map((item) => {
            if (aAction === 'add') {
                this.baskeList.add(item);
            } else {
                this.updateSelected(item.doc_docid);
            }
        });
        if (aAction === 'del') {
            this.displayresultgrid.selectedDocs.length = 0;
        }
    }

    private updateBasketThumb(aAction) {
        let wItem;
        this.dataView.selectedList.map((item) => {
            if (item.selected === true) {
                wItem = this.findInResult(item.doc_docid);
                if (wItem !== undefined) {
                    if (aAction === 'add') {
                        this.baskeList.add(wItem);
                    } else {
                        this.updateSelected(wItem.doc_docid);
                    }
                }
            }
        });
        if (aAction === 'del') {
            this.dataView.selectedList = [];
            this.dataView.thumbList.map((item) => {
                this.dataView.updateSelectedList(item);
            });
        }
    }

    private updateSelected(id) {
        this.baskeList.remove(id);
        this.removeInResult(id);
        if (this.modeView === 'T') {            
            this.dataView.remove(id);
        }
    }

    private findInResult(id) {
        return this.resultDisplay.find((item) => {
            return item.doc_docid === id;
        });
    }

    private removeInResult(id) {
        this.resultDisplay = this.resultDisplay.filter((item) => {
            return item.doc_docid !== id;
        });
    }

    private async getInfosDoc(adocid, aUpdate, event, aDocName) {
        let wRes: any;
        this.initInfosdoc();
        try {
            wRes = await lastValueFrom(this.documentService.readInfosDoc(aUpdate, this.indexedDbService.variableStorage));
            this.processInfosDoc(wRes, adocid, aDocName, event)            
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
    }

    private processInfosDoc(aRes, adocid, aDocName, event) {
        this.setBaseInfos(aRes, adocid);
        this.setPathPdfImg(adocid);
        this.displayresultgrid.pathPdf = this.pathPdf;
        this.paramDetail.pathPdf = this.pathPdf;
        this.paramDetail.pathImg = this.pathImg;
        localStorage.setItem('urlsource', this.pathPdf);
        this.rightService.getRight(this.docInfos);
        this.setActions();
        this.displayresultgrid.setShowThumb(false);
        this.displayresultgrid.currentDocId = adocid;
        this.displayresultgrid.setSelectedDocIndex();
        this.displayresultgrid.setNumPageFromIndex(this.displayresultgrid.curIndex);
        this.setDocIdList(adocid, aDocName);
        if (this.modeView !== 'D') {
            this.onReturnResult.emit('');
        }
        this.selectedDocsExport.length = 0;
        this.allowReorg = 'visible';
        this.selectedDocsExport.push(event.data);
        if (this.docIdinBasket === false) {
            this.refreshDataAfterUpdate('delete', '', adocid);
            this.nbDoc--;
            this.titleDetail = this.tools.setTitleDetail(this.srchMode, this.nbDoc);
            this._messageService.addWarn(this.translate.instant('Doc_NotBsk'));
        } else {
            if (this.originClick === 'L') {
                this.onReturnResult.emit('');
                this.visuGrid = 2;
            }
            if (this.autoDocId !== '') {
                this.autoDocId = '';
                this.visuGrid = 2;
            }
            this.nbZoneDisplay = {
                nbFollowLeft: this.getZone(this.rightService.typeAction.TDTra),
                nbFollowRight: this.getZone(this.rightService.typeAction.TBList),
                nbBskLeft: this.getBskLeft(),
                nbBskRight: this.getBskRight(),
                nbDocLeft: this.getDocZone(this.bskMode, this.rightService.typeAction.TDInfo, this.rightService.typeAction.TDAft),
                nbDocRight: this.getDocZone(this.bskMode, this.rightService.typeAction.TDVar, this.rightService.typeAction.TDCom),
            }
            this.setParamDetail();
            if (this.paramDetail.typeView === 3) {
                this.paramDetail.dockBase = this.panelService.delDock(this.paramDetail.dockBase, 'dockVisu');
            }
        }
        if (this.documentDetail) {
            this.documentDetail.showCustom = true;
        }
    }

    private setPathPdfImg(aDocId) {
        this.pathPdf = this.api.getPdf(aDocId);
        this.pathImg = this.api.getThumb(aDocId, 800);
    }

    private setParamDetail() {
        this.paramDetail = {
            initialize: true,
            currentSelectedBsk: this.currentSelectedBsk,
            bskParamDock: this.bskParamDock,
            rightService: this.rightService,
            infosMailDisplay: this.infosMailDisplay,
            bskTypeMail: this.bskTypeMail,
            viewIndex: this.viewIndex,
            bskMode: this.bskMode,
            docInfos: this.docInfos,
            docIndex: this.docIndex,
            docIndexFiltered: this.docIndexFiltered,
            docBasket: this.docBasket,
            docAtf: this.docAtf,
            displayBskVariableUpdate: this.displayBskVariableUpdate,
            listBskVariableUpdate: this.listBskVariableUpdate,
            currentDocId: this.currentDocId,
            currentDocName: this.currentDocName,
            dockDyn: this.currentSelectedBsk.bskDockDyn,
            isLock: this.isLock,
            atfActions: this.atfActions,
            editorService: this.editorService,
            nbZoneDisplay: this.nbZoneDisplay,
            typeView: this.typeView,
            pathPdf: this.pathPdf,
            pathImg: this.pathImg,
            isDesktop: this.isDesktop,
            menuImage: this.menuImage,
            reorgBsk: this.reorgBsk,
            btDocActionList: this.btDocActionList,
            currentVer: this.currentVer,
            dockBase: this.getPanels(this.rightService, this.currentSelectedBsk, this.bskTypeMail, this.infosMailDisplay, this.displayBskVariableUpdate, this.currentSelectedBsk.bskDockDyn, this.basketMoveAll),            
        }        
    }

    private getPanels(aRightService, aCurrentSelectedBsk, aBskTypeMail, aInfosMailDisplay, aDisplayBskVariableUpdate, aDockDyn, aBasketMoveAll) {
        this.panelService.signEngineDock = this.documentService.getPropertyValue('sys_signengine') === '' ? false : true;
        return this.panelService.getPanelBase(aRightService, aCurrentSelectedBsk, aBskTypeMail, aInfosMailDisplay, aDisplayBskVariableUpdate, aDockDyn, true, aBasketMoveAll);
    }

    private getDocZone(aBskMode, aAction1, aAction2) {
        let wNbZone = 0;
        wNbZone = wNbZone + this.getZone(aAction1);
        if (aBskMode === false) {
            wNbZone = wNbZone + this.getZone(aAction2);
        }
        return wNbZone;           
    }

    private getZone(aAction) {
        let wNbZone = 0;
        if (aAction === true) {
            wNbZone = 1;
        }
        return wNbZone;
    }

    private getBskLeft() {
        let wNbZone = 0;
        if (this.bskMode === true) {
            if (this.rightService.typeAction.TDAft === true) {
                wNbZone++;
            }
            if (
                ['InvoiceValidation', 'MailDispatching', 'MailValidation'].indexOf(
                    this.currentSelectedBsk.bskTypeDock
                ) > -1
            ) {
                wNbZone++;
            }
        }        
        return wNbZone;
    }

    private getBskRight() {
        let wNbZone = 0;
        if (this.bskMode === true) {
            if (this.displayBskVariableUpdate === true) {
                wNbZone++;
            }
            wNbZone = wNbZone + this.getZone(this.rightService.typeAction.TDCom);         
        }        
        return wNbZone;
    }

    private async getInfosDocVer(adocid) {
        let wRes: any;
        this.initInfosdocVer();
        try {
            wRes = await lastValueFrom(this.documentService.readInfosDocVer(adocid, this.indexedDbService.variableStorage));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }  
        this.setInfosVer(wRes, adocid);
        this.setPathPdfImg(adocid);
        this.nbZoneDisplay = {
            nbFollowLeft: this.getZone(this.rightService.typeAction.TDTra),
            nbFollowRight: 0,
            nbDocLeft: this.getDocZone(false, this.rightService.typeAction.TDInfo, false),
            nbDocRight: this.getDocZone(false, this.rightService.typeAction.TDVar, this.rightService.typeAction.TDCom),
        }
    }

    private setInfosVer(val, adocid) {
        this.docInfosVer = val.getInfoDoc.Document; 
        this.docIndexFilteredVer = val.getIndexDoc.VariableList.Variable.filter((item) => {
            if (!this.isAdmin) {
                if (item.Name.substring(0, 4) !== 'sys_') {
                    return item;
                }
            } else {
                return item;
            }
        });
        this.docIdVer = adocid;
    }

    private setBaseInfos(val, adocid) {
        this.editorService.setCustomEditorList(val.getEditorList.CustomEditorList);        
        this.docInfos = val.getInfoDoc.Document;        
        this.docIndex = val.getIndexDoc.VariableList.Variable;
        this.docIndexFiltered = val.getIndexDoc.VariableList.Variable.filter((item) => {
            if (!this.isAdmin) {
                if (item.Name.substring(0, 4) !== 'sys_') {
                    return item;
                }
            } else {
                return item;
            }
        });
        this.docBasket = this.setDocBasket(val);
        this.docAtf = val.getAtfDoc.AtfList.Atf.map((item) => {
            if (item.Extension === extGed) {
                item.allowTrs = false;
                item.allowCnv = false;
            } else {
                item.allowTrs = true;
            }
            item.visu = true;
            return item;
        })
        this.customService.setBaseValues(this.docInfos, this.docIndex, this.listBskVariable, this.currentSelectedBsk, this.docAtf);
        this.documentService.setValues(this.docIndex);
        this.documentService.setBskMode(this.bskMode);
        this.setGeneric();
        this.displayBskVariableUpdate = displayResultTools.getDisplay(this.listBskVariableUpdate);
        this.setDataBsk(adocid);
        this.docIdinBasket = true;
        if (this.bskMode === false) {
            this.editorService.updateBasketIndexList(this.docIndex, this.listBskVariableUpdate);
        } else {
            this.docIdinBasket = this.docInBasket(this.docBasket, this.currentSelectedBsk.bskName.toUpperCase());
        }
        this.editorService.varListSave = JSON.stringify(this.listBskVariableUpdate);
        this.currentLockUser = getProperty(this.docInfos, 'CheckoutUser');
        this.isLock = displayResultTools.isLock(this.currentUser, this.currentLockUser);
        this.lockDate = getProperty(this.docInfos, 'CheckoutDate');
        this.splitId = adocid;
        // this.setParamDetail();
    }

    private docInBasket(aList, aBskName) {
        let wIndex = -1;
        wIndex = aList.findIndex((item) => item.name.toUpperCase() === aBskName);
        return wIndex !== -1;
    }

    private setDataBsk(adocid) {
        let windex = -1;
        if (this.bskMode === true) {
            windex = this.getIndexFromResDisp(adocid);
            if (windex !== -1) {
                this.setBskProperty(this.currentSelectedBsk.bskType, this.resultDisplay[windex]);
                this.currentBskProperty = this.setcurrentBskProperty(
                    this.currentSelectedBsk.bskType,
                    this.resultDisplay[windex]
                );
            }
        }
    }

    private setDocBasket(aData) {
        let wLabel = '';
        return aData.getBasketsDoc.basketlist.basket.map((item) => {
            wLabel = this.get_bskLabel(item.name);
            item.Label = decodeUtf8(wLabel);
            item.value = '';
            if (item.type === 'Mail') {
                item.value = getField(item.status);
            }
            return item;
        });
    }

    private get_bskLabel(aName) {
        let wName: any;
        wName = this.api.bskListAll.filter((item) => {
            return item.name === aName;
        })
        if (wName[0] !== undefined) {
            if (wName[0].label !== '') {
                return wName[0].label;
            } else {
                return aName;
            }
        }
    }

    private setGeneric() {
        let witem;
        let wType;
        let wDataCombo = {
            type: '',
            comboValue: '',
            DefaultValue: '',
            pattern: '',
            Editable: false,
        };
        if (this.bskMode) {
            this.bskVariableList = JSON.parse(
                JSON.stringify(this.editorService.prepareListVar(this.listBskVariable, this.docIndex))
            );
            this.listBskVariableUpdate = JSON.parse(JSON.stringify(this.bskVariableList));
            this.bskParamDock = this.dockStandardService.getParamDock(
                this.currentSelectedBsk.bskTypeDock,
                this.currentSelectedBsk.bskName,
                this.docIndex
            );
        } else {
            this.listBskVariableUpdate = [];
            for (let i = 0; i < this.docIndex.length; i++) {
                witem = new Object();
                witem.DefaultValue = this.docIndex[i].DefaultValue;
                witem.Label = this.docIndex[i].Label;
                witem.name = this.docIndex[i].Name;
                witem.Required = false;
                witem.system = false;
                witem.Editable = false;
                witem.disabled = false;
                wType = this.editorService.getTypeFromVarEditorList(
                    this.docIndex[i].Name,
                    this.docIndex[i].value,
                    true
                );
                witem.type = wType.type;
                wDataCombo = this.setCombo(wType);
                if (wDataCombo) {
                    witem.type = wDataCombo.type;
                    witem.comboValue = wDataCombo.comboValue;
                    if (wDataCombo.Editable === true) {
                        witem.DefaultValue = witem.DefaultValue;
                    } else {
                        witem.DefaultValue = wDataCombo.DefaultValue;
                    }
                    witem.pattern = wDataCombo.pattern;
                    witem.Editable = wDataCombo.Editable;
                }
                this.listBskVariableUpdate.push(witem);
            }
            this.editorService.updateVariable(this.listBskVariableUpdate);
        }
    }

    private setCombo(aType) {
        const type = {
            ListUsers: this.getValueCombo,
            ListGroups: this.getValueCombo,
            ListDB: this.getValueCombo,
            ComboCustom: this.getValueCombo,
            Combo: this.getValueCombo,
            EditMask: this.getValueCombo,
        };
        if (type[aType.type]) {
            return type[aType.type](aType);
        } else {
            return null;
        }
    }

    private getValueCombo(aType) {
        let wType = {
            type: '',
            comboValue: '',
            DefaultValue: '',
            pattern: '',
            Editable: false,
            disabled: false,
        };
        wType.type = aType.type;
        wType.comboValue = aType.option;
        wType.DefaultValue = aType.default.displayValue;
        wType.pattern = aType.pattern;
        wType.Editable = aType.Editable;
        wType.disabled = aType.disabled;
        return wType;
    }

    private initInfosdoc() {
        this.docInfos = null;
        this.docIndex = null;
        this.docBasket = null;
        this.docAtf = null;
        this.docVersion.set([]);
        this.pathPdf = '';
        this.pathImg = '';
        this.editorService.varListSave = '';
    }

    private initInfosdocVer() {
        this.docInfosVer = null;
        this.docIndexFilteredVer = null;
        this.docIdVer = '';
    }

    public goPreviousDoc() {
        if (this.displayresultgrid.curIndex === 0) {
            return;
        }
        this.nextPrevDoc('p');
    }

    private prevDoc() {
        this.verifyAndSetTypeView();
        this.unsubscribeComm();
        if (this.displayresultgrid.verifyGoPreviousPage() === true) {
            this.goPreviousPage();
            if (this.displayresultgrid.curIndex === 0) {
                this.displayresultgrid.setCurrentIndex(this.displayresultgrid.nbRow);
            }
            this.setSelection();
        } else {
            let windex = this.displayresultgrid.getSelectedDocIndexFromId();
            windex--;
            if (windex >= 0) {
                this.displayresultgrid.setCurrentIndex(windex);
                this.setSelection();
            }
        }
    }

    public goNextDoc() {
        if (this.displayresultgrid.verifyGoNextDoc() === true) {
            return;
        }
        this.nextPrevDoc('n');
    }

    private nextPrevDoc(aSens) {
        if (this.verifyComment() === true) {
            if (this.internalPrefUsr.displayConfirm === true) {
                this.setSubject();
                this.displayComm$.subscribe({next:() => {
                    this.execVerifyPrevOrNextDoc(aSens);
                }});                
            } else {
                this.saveCommAndGo(aSens);
            }
        } else {
            this.execVerifyPrevOrNextDoc(aSens);
        }
    }

    private saveCommAndGo(aSens) {
        this.onClickSaveComm(true, false).then(() => {            
            this.execVerifyPrevOrNextDoc(aSens);
        })
    }

    private execVerifyPrevOrNextDoc(aSens) {
        if (this.verifyModified()) {
            this.saveIndexAndGo(aSens);
        } else {
            this.goNextOrPrevDoc(aSens);
        }
    }

    private saveIndexAndGo(aSens) {
        if (this.internalPrefUsr.displayConfirm === true) {
            this.itemConfirm.confirmAction(
                'warning',
                this.translate.instant('Save_Idx'),
                (accept) => {
                    this.updateIndex(aSens, false);
                },
                (reject) => {
                    this.goNextOrPrevDoc(aSens);
                }
            );
        } else {
            this.updateIndex(aSens, false);
        }
    }

    private goNextOrPrevDoc(aSens) {

        this.documentDetail.showCustom = false
        if (aSens === '') {
            return;
        }
        if (aSens === 'n') {                        
            this.nextDoc();
        } else {
            this.prevDoc();
        }
    }

    private nextDoc() {
        this.verifyAndSetTypeView();
        this.unsubscribeComm();
        if (this.displayresultgrid.verifyNextDoc() === true) {
            this.goNextPage();
            this.setSelection();
        } else {
            let windex = this.displayresultgrid.getSelectedDocIndexFromId();
            windex++;
            if (windex < this.displayresultgrid.dataTableUse.totalRecords) {
                this.displayresultgrid.setCurrentIndex(windex);
                this.setSelection();
            }
        }
    }

    // Positionnemt du type de vue en mode image si type de vude en mode action (bug pdfaction)
    private verifyAndSetTypeView() {
        if (this.typeView === 1) {            
            this.resetView(2);
        }
    }

    public setTotalDoc(aTotDoc) {
        this.displayresultgrid.setTotalDoc(aTotDoc);
    }

    private verifyModified() {
        if (this.isLock === true) {
            return false;
        }
        if (this.editorService.varListSave === '') {
            return false;
        }
        if (this.actionGroup === true) {
            return false;
        }
        if (this.editorService.varListSave === JSON.stringify(this.listBskVariableUpdate)) {
            return false;
        } else {
            return true;
        }
    }

    public onPageChange($event) {
        this.splitId = $event;
        if (this.modeView === 'S') {
            this.setViewSplit(this.modeView);
        }
        if (this.modeView === 'D') {
            this.currentDocId = undefined;  // pour forcer la lecture
            this.setViewSplit(this.modeView);
        }
    }

    private goNextPage() {
        if (this.displayresultgrid.verifyGoNextPage() === true) {
            this.displayresultgrid.goNextPage();
            this.setDataViewIndex('n');
        }
    }

    private goPreviousPage() {
        this.displayresultgrid.goPreviousPage();
        this.setDataViewIndex('p');
    }

    private setDataViewIndex(aSens) {
        if (this.dataView) {
            if (aSens === 'n') {
                this.dataView.setFirst(this.displayresultgrid.getCurrentIndex());
            } else {
                this.dataView.setFirst(this.displayresultgrid.dataTableUse.first);
            }
        }
    }

    private setSelection() {
        this.displayresultgrid.setSelection();
        this.verifyClickItem(this.displayresultgrid.currentDocId);
    }

    private verifyClickItem(aDocId) {
        let windex = -1;
        let wParam: any;
        windex = this.getIndexFromResDisp(aDocId);
        if (windex !== -1) {
            wParam = new Object();
            wParam.data = this.resultDisplay[windex];
            this.clickItem(wParam);
        }
    }

    public goResultDoc() {
        this.resetOutlet();
        this.visuGrid = 1;
        this.displayresultgrid.selectedDocs = [];
        if (this.resultDisplay.length !== 0) {
            this.splitId = this.resultDisplay[this.displayresultgrid.curIndex].doc_docid;
            this.originClick = '';
            if (this.modeView === 'D' || this.modeView === 'S') {            
                this.setViewSplit(this.modeView);
            }
        }
    }
    
    public setViewSplit(aMode) {
        this.setPathPdfImg(this.splitId);
        if (aMode === 'D') {
            this.setViewDetail();
        }
    }

    public setViewDetail() {
        if (this.currentDocId !== this.splitId) {
            this.currentDocId = undefined;
        }
        if (this.currentDocId === undefined) {
            this.verifyClickItem(this.splitId);
        }
    }

    public goNextDocs() {
        this.onNextDocs.emit();
    }

    private goGrid() {
        this.originClick = '';
        this.modeView = 'G';
        this.listColumnsWrk = [...this.listColumns];
    }

    private goThumb(aSize) {
        this.originClick = '';
        this.modeView = 'T';
        this.sizeThumb = aSize;
    }

    private goSplit() {
        this.originClick = '';
        this.modeView = 'S';
        this.setViewSplit(this.modeView);
    }

    private goDetail() {
        this.originClick = '';
        this.modeView = 'D';
        this.setViewSplit(this.modeView);
    }

    private goAddBasket() {
        this.onClickAddBasket(true);
    }

    private goClickExport() {
        this.onClickExport(true);
    }

    private goClickExportXlsx() {
        this.onClickExportXlsx(true);
    }   

    private goClickStat() {
        this.onClickStat(false);
    }

    private goClickSendMail() {
        this.onClickSendMail(true);
    }

    private goClickTransBsk() {
        this.onClickTransBsk(true);
    }

    private goClickDelBsk() {
        this.onClickDelBsk(true);
    }

    private goOnDel() {
        this.onDel('deletebsk');
    }    

    private goOnDelGed() {
        this.onDel('deleteged');
    }

    private goOnTransGed() {
        this.currentAction = 'move';
        this.currentAtf = '';
        this.getBasketTransfert(false);
    }

    private goOnSendMail() {
        this.onSendMail('sendmail');
    }

    private goOnVer() {
        this.onVer('versionning');
    }

    private goOnCompose() {
        this.onCompose('compose');
    }

    private goOnPreviousDoc() {
        this.goPreviousDoc();
    }

    private goOnNextDoc() {
        this.goNextDoc();
    }

    private goOnDownload(aType) {
        this.onDownload(aType);
    }

    private goOnLockUnlock() {
        this.onLockUnlock();
    }

    private goOnMoveDoc() {
        this.onClickMoveDoc(true);
    }

    private goOnRenameDoc() {
        this.onRenameDoc('rename');
    }

    public onClickGridActionList($event) {
        $event.call();
    }

    public onClickDocActionList($event) {
        $event.call();
    }

    public showModal(event) {
        this.hideButton = event;
    }
}
